import React, { useEffect, useRef, useState} from 'react';
import DataGrid from 'react-data-grid';
import 'react-data-grid/lib/styles.css'
import { Storage} from "aws-amplify";
import './AllFeatures.less';
import {columns} from './static/columns' 
import {useDispatch, useSelector} from 'react-redux'
import {CardGridActions} from '../actions/CardGridAction'
import {CardDetailActions} from '../actions/CardDetailAction'
import AddCard from './modal/AddCard'
import MoreFilters from './modal/MoreFilters'
import _ from 'lodash'

Storage.configure({ level: "protected" });
  
   const CardGrid = (props) => {

 

    const gridRef = useRef(null);
    const dispatch = useDispatch()
    const [[sortColumn, sortDirection], setSort] = useState(['id', 'NONE']);
    const [sortColumns, setSortColumus] = useState([]);
    const [filteredRows, setFilteredRows] = useState([])
    const [loading, setLoading] = useState('ui  dimmer')

    const cardData = useSelector(state => state.cardGrid)
    const cgData =  useSelector(state => state.cardGrid.cardGridData)
     const onCardChange = (data) => {
      console.log('ORC ' + data)
      
     } 

/**Column Data */
const defaultColumnProperties = {
  sortable: true
};

  const [custCols, setCustCols] = useState(_.cloneDeep(columns))


    const [filters, setFilters] = useState({
      year: '',
      condition: '',
      setName: 'All',
      player: '',
      cardNum: '',
      price: 0,
      graded: 'All',
      autograph: '',
      gameUsed: '',
      showSold: false,
      showCompleteSet: true,
      qualifier: 'All'
    })

    
    const handleSort = (columnKey) => {

      dispatch(CardGridActions.sortGrid(cardData, columnKey[0].columnKey))
      
    };
  
    
    

    function processColumnList(props) {
      if (props.gallery === 'true') {
        let editRemoved = _.filter(custCols, function(o) { return o.key !== 'edit'; })
        return editRemoved
      }
      else {
        return _.cloneDeep(columns)
      }
  }

  function rowKeyGetter(row) {
    return _.findIndex(cardData.cardGridData, ['id', row.id]);
  }
    const onRowSelect = (row) => {
      console.log('ORS2 ' + JSON.stringify(row))
      let selIdx = rowKeyGetter(row)
      console.log('ORS2-idx ' + selIdx) 
      if (filteredRows && filteredRows[row]) {
        const realIndex = _.findIndex(cardData.cardGridData, ['id', filteredRows[row].id]);
        selIdx = realIndex
      }
      if (cardData.selectedCard !== selIdx) {
          dispatch(CardDetailActions.getCardDetails(cardData.cardGridData[selIdx]))
          dispatch(CardGridActions.selectGridItem(selIdx, props.gallery))  
      }
    }


    //Handle Additional Filters
    useEffect(() => {  
      if (cardData.additionalFilters) {
        setFilters(_.assign(filters, cardData.additionalFilters))
        handleFilterChange(filters)  //force a filter update 
      }
      // eslint-disable-next-line
    }, [cardData.additionalFilters]);

    useEffect(() => {  
      if (cgData) {
        console.log('not null')
      }
      else {
        console.log('cgdata is null')
      } 
      // eslint-disable-next-line
    }, [cgData]);
    

useEffect(() => {  
  if (cardData.lastAdded) {
    handleFilterChange(filters)  //force a filter update after a new card is added to ensure that it is visible
  }
  // eslint-disable-next-line
}, [cardData.lastAdded]);


    useEffect(() => {  
      if (cardData.gridLoading) {
          setLoading('ui active dimmer')
      }
      else {
          setLoading('ui dimmer')
      }
    }, [cardData.gridLoading]);

    useEffect(() => {
      if (cardData.selectedCard) {
        let scrollIndex = _.findIndex(filteredRows, ['id', cardData.cardGridData[cardData.selectedCard].id]);
        if (scrollIndex === -1) {  //if a file was just added to the list, it will not be found (returning -1)  - in this case, we want to scroll to the bottom 
            scrollIndex = filteredRows.length
        }
        gridRef.current.scrollToRow(scrollIndex)
        console.log('selected card updated ' + scrollIndex)
      }
      // eslint-disable-next-line
    }, [cardData.selectedCard]);

    useEffect(() => {
    //remove the edit column if this is a readonly gallery view
    dispatch(CardGridActions.gridDataInit())  //set the grid to 'loading' status
    dispatch(CardGridActions.getInitVals())   //get the set list & other drop down defaults
    let newCols = processColumnList(props)
      if (props.gallery === 'true') {
        //let editRemoved = _.filter(custCols, function(o) { return o.key !== 'edit'; })
        //console.log('remove e ' + JSON.stringify(editRemoved))
        setCustCols(newCols)
        dispatch(CardGridActions.fetchGallery())
      }
      else {

        setCustCols(newCols)
        dispatch(CardGridActions.getUserGrid())
      }
     // eslint-disable-next-line
    }, [dispatch, props.gallery]);

    useEffect(() => {
      console.log('here!')
      if (cardData.cardGridData) {
        setFilteredRows(cardData.cardGridData)
        handleFilterChange(filters)
      }
      else {
        console.log('no data yet')
      }
            // eslint-disable-next-line
    }, [cardData.cardGridData]);
    //Replace the columns array - setName value with a dynamic version - when the list of values loads in
    useEffect(() => {
      if (cardData.setList) {
        document.getElementById('setList').innerHTML=buildSetDropDown()
      }
      // eslint-disable-next-line
    }, [cardData.setList]);

    function updateFilter(filterName, filterVal) {
      console.log(filterName + filterVal + ' gl ' + cardData.gridLoading)
      let origFilters = filters;
      origFilters[filterName] = filterVal
      setFilters(origFilters)
      handleFilterChange(filters) 
  }

  function handleFilterChange (filter) {
      
    const filtersChanged =  !_.isEqual(filter, filters)
    //console.log('FILTER CHG ' + filtersChanged)
    setFilters(filter)

    if (cardData.cardGridData || cgData) {
      let filteredData = cardData.cardGridData.filter(r => {
      //console.log(JSON.stringify(filter))
        return (
          (              
            filter.year && filter.year.length === 4 ? parseInt(r.year) === parseInt(filter.year) : true)
            && (filter.condition ? parseInt(r.condition) === parseInt(filter.condition) : true)
            && (filter.setName !== 'All' ? r.setName === filter.setName : true)
            && (filter.graded !== 'All' ? r.graded === filter.graded : true)
            && (filter.qualifier !== 'All' ? r.qualifier === filter.qualifier : true)
            && (filter.autograph !== '' ? r.autograph.toString() === filter.autograph : true) 
            && (filter.gameUsed !== '' ? r.gameUsed.toString() === filter.gameUsed : true)
            && (filter.player !== '' ? r.player.toLowerCase().includes(filter.player.toLowerCase()) : true)
            && (!filter.showSold ? !r.sold : true)  //Exclude Cards that have been 'sold'
            && (!filter.includeCompleteSets && filter.includeCompleteSets!== undefined ? !r.completeSetId : true)  //Exclude Cards that are part of complete set
            && (filter.cardNum !== '' ? r.cardNum.toLowerCase().includes(filter.cardNum.toLowerCase()) : true)
            && (filter.price && parseInt(filter.price) > 0 ? parseInt(r.price) > parseInt(filter.price) : true)
          // && (filters.complete ? filters.complete.filterValues(r, filters.complete, 'complete') : true)
        );
      });
    
      setFilteredRows(filteredData)
    
      //If the filter was changed, just set the row to the 1st filtered value
      if (filtersChanged) {
        onRowSelect(_.findIndex(cardData.cardGridData, filteredData[0]))
      }
    }
    else {
      console.log('Filter failed b/c card data is not loaded ' + cardData.gridLoading + cgData)
    }
}
function buildSetDropDown() {
  let result = '<option value="All">All</option>'
  for (var setItem in cardData.setList) {
    result += '<option value="' + cardData.setList[setItem].setName + '" key="' + cardData.setList[setItem].setName + '"> ' + cardData.setList[setItem].setName + "<option>"
  }
  return result
}
      return (
        <div className="ui container all-features">
          <div className={loading}>
                    <div className="ui loader"></div>
          </div>
            <div className="ui inverted segment">
              <div className="ui three small statistics">
                <div className="ui inverted small statistic">
                  <div className="value">{filteredRows ? filteredRows.length : 0}</div>
                  <div className="label">Total Cards</div>
                </div>
                <div className="ui red inverted small statistic">
                  <div className="value">
                    {filteredRows ? _.sum( _.map(filteredRows, 'price')) : 0}
                  </div>
                  <div className="label">
                    Total Value
                  </div>
                </div>
                <div className="ui orange inverted small statistic">
                  <div className="value">
                  {props.gallery !== 'true' && <AddCard/>} 
                  {props.gallery !== 'true' && <MoreFilters/>}  
                  </div>
                </div>
              </div>   
          </div>
          {/* //Filter Row */}
          <div className="ui menu">
          <div className="item">
                <div className="ui small input">
                <input style={{width:"49px"}} type="text" size="4" onChange={e => updateFilter('year', e.target.value)}></input>
                </div>
              </div>
              <div className="item">
                <div className="ui small input">
                    <select id="setList" className='ui fluid input' style={{width:"117px"}} onChange={e => updateFilter('setName', e.target.value)}>  
                      <option value="All">All</option>
                    </select>
                </div>
              </div>
              <div className="item">
                <div className="ui small input">
                <input style={{width:"129px"}}type="text" onChange={e => updateFilter('player', e.target.value)}></input>
                </div>
              </div>
              <div className="item">
                <div className="ui small input">
                <input style={{width:"48px"}}type="text" onChange={e => updateFilter('cardNum', e.target.value)}></input>
                </div>
              </div>
              <div className="item">
                <div className="ui small input">
                <input style={{width:"48px"}}type="text" onChange={e => updateFilter('condition', e.target.value)}></input>
                </div>
              </div>
              <div className="item">
                <div className="ui small input">
                  <select className='ui select' style={{width:"58px"}}  onChange={e => updateFilter('graded', e.target.value)}>
                    <option value="All">All</option>
                    <option value="RAW">RAW</option>
                    <option value="PSA">PSA</option>
                    <option value="SGC">SGC</option>
                    <option value="BVG">BVG</option>
                    <option value="GAI">GAI</option>
                  </select>
                </div>
              </div>
              <div className="item">

              <div className="ui small input">
              <select className='ui select' style={{width:"72px"}} onChange={e => updateFilter('qualifier', e.target.value)}>
                  <option value="All">All</option>
                  <option value="None">None</option>
                  <option value="OC">OC</option>
                  <option value="MC">MC</option>
                  <option value="MK">MK</option>
                  <option value="OF">OF</option>
                </select>
                </div>
              </div>
              <div className="item">
                <div className="ui small input">
                  <select style={{width:"48px"}} className='ui select'  onChange={e => updateFilter('gameUsed', e.target.value)}>
                    <option value="">All</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select> 
                </div>
              </div>
              <div className="item">
              <div className="ui small input">
                  <select style={{width:"48px"}} className='ui select'  onChange={e => updateFilter('autograph', e.target.value)}>
                    <option value="">All</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select> 
                </div>
              </div>
              <div className="item">
                <div className="ui small input">
                <input style={{width:"73px"}} type="text" onChange={e => updateFilter('price', e.target.value)}></input>
                </div>
              </div>
              
          </div>
            <DataGrid
              ref={gridRef}
              columns={custCols}
              rowKeyGetter={rowKeyGetter}
              rowGetter={i => cardData.cardGridData[i]}
              enableCellSelect={false}
              enableCellAutoFocus={false} 
              rows={filteredRows}
              headerRowHeight={35}
              onRowsChange={onCardChange}
              onRowClick={onRowSelect}
              sortColumns={sortColumns}
              onSortColumnsChange={handleSort}
              sortColumn={sortColumn}
              sortDirection={sortDirection}
              onSort={handleSort}
              enableFilterRow={true}
              filters={filters}
              className="fill-grid"
              style={{ height: '550px' }}
              onFiltersChange={handleFilterChange}
            />
          </div>
      );

  }


  export default CardGrid



